export default __webpack_public_path__ + "static/media/paw.827dc280.png";